import { StyleSheet } from 'react-native';
import { SURFACE_CARD_RADIUS_CONTENT } from '../surface-cards/public-api';
import { spacing, ticketColors, ticketFonts } from '../theme/public-api';

/**
 * Chrome de tabla PC ticket (referencia Catálogo).
 * Usar en Gastos / Ventas / Customer / Stock / Promos.
 */
export const ticketDeskTable = StyleSheet.create({
  tableOuter: {
    width: '100%',
    maxWidth: '100%',
    alignSelf: 'stretch',
    marginBottom: spacing.sm,
  },
  tableOuterEmbedded: {
    marginBottom: 0,
    flex: 1,
  },
  table: {
    width: '100%',
    borderRadius: SURFACE_CARD_RADIUS_CONTENT,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper2,
    overflow: 'hidden',
  },
  tableEmbedded: {
    borderWidth: 0,
    borderRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: 56,
    paddingVertical: 12,
    paddingHorizontal: 14,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: ticketColors.ruleSoft,
    gap: spacing.sm,
  },
  headerRow: {
    minHeight: 40,
    paddingVertical: 10,
    paddingHorizontal: 14,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: ticketColors.rule,
    backgroundColor: ticketColors.paper2,
  },
  headerCell: {
    fontSize: 10.5,
    color: ticketColors.ink3,
    fontWeight: '800',
    textTransform: 'uppercase',
    letterSpacing: 0.6,
    fontFamily: ticketFonts.sans,
  },
  headerNum: {
    textAlign: 'right',
    width: '100%',
  },
  cell: {
    fontSize: 13,
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },
  cellMuted: {
    fontSize: 11,
    lineHeight: 14,
    color: ticketColors.ink3,
    fontWeight: '500',
    fontFamily: ticketFonts.sans,
  },
  moneyText: {
    fontSize: 14,
    color: ticketColors.ink,
    fontWeight: '700',
    fontFamily: ticketFonts.mono,
    fontVariant: ['tabular-nums'],
    letterSpacing: -0.3,
    textAlign: 'right',
  },
  statusText: {
    fontSize: 11,
    fontWeight: '600',
    letterSpacing: 0.4,
    textTransform: 'uppercase',
    color: ticketColors.ink3,
    fontFamily: ticketFonts.sans,
  },
  statusOk: {
    color: ticketColors.ok,
  },
  statusWarn: {
    color: ticketColors.warn,
  },
  statusBad: {
    color: ticketColors.bad,
  },
  statusPause: {
    color: ticketColors.ink3,
  },
});
